<template>
    <div class="approve-model-content">
        <div class="opera-tit-btn">
            <div class="tit">{{approveModelTit}}</div>
            <div class="btn"><el-button type="primary" @click="saveData">保存数据</el-button></div>
        </div>
        <div class="model-form">
            <el-form class="float:left" size="mini" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="模型名称">
                            <el-input placeholder="请输入内容" v-model.trim="modelData.modelName"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="模型描述">
                            <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="modelData.remarks" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                     <el-col :span="24">
                        <el-form-item label="审批表单"
                         :rules="[
                            { required: true, message: '请选择审批表单', trigger: 'change' },
                          ]"
                        >
                            <TreeSelect
                                :isRead="isRead"
                                ref="treeSelect"
                                :sourceOptions="appModelsOptions"
                                @treeSelectChoose="handleSelectForm"
                            />
                        </el-form-item>
                     </el-col>
                 </el-row>
            </el-form>
        </div>
        <div class="approve-preview" v-if="showApproveContent">
            <el-collapse  v-model="collapseActiveName" accordion>
                <el-collapse-item v-for="(form, index) in forms" :key="form.id" :title="form.formName" :name="form.id">
                    <template slot="title">
                        <div class='el-collapse-title'>
                            <span>【{{form.formName}}】</span>
                        </div>
                    </template>
                    <el-form :model="formData[index].values" :ref="'customForm'+index" label-width="165px" :id="`print${form.id}`">
                        <FieldItem v-for="(field,index2) in form.fieldsList" :findex="index2" :formId="form.id"  :formConfig="form"  :key="field.fieldId" :field="field" :formData="formData[index].values" :isBelongApproval="true" :colSpan="form.colSpan" :fieldsList="form.fieldsList"/>
                    </el-form>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>

<script>
import { getApplicationModelTreeList, getFormConfigs, getApproveData } from '@/data-model';
import { cloneDeep } from 'lodash';
export default{
    data () {
        return {
            modelData: {
                modelName: '',
                remarks: '',
                formIds: '',
                modelIds: '',
                id: '',
                formId: ''
            },
            isRead: false,
            appModelsOptions: [],
            collapseActiveName: '',
            forms: [],
            formData: [],
            selectData: [],
            showApproveContent: false
        };
    },
    props: {
        approveModelTit: {
            type: String
        },
        approveFormId: {
            type: String
        },
        approveModelName: {
            type: String
        },
        approveModelRemark: {
            type: String
        }
    },
    created () {
        this.initFormData();// 初始化下拉表单数据
    },
    methods: {
        async initApproveData () {
            let res = await getApproveData(this.approveFormId);
            this.modelData.formId = this.approveFormId;
            this.modelData.id = res.id;
            this.modelData.formIds = res.approveFromIds;
            this.modelData.modelIds = res.approveModelIds;
            let formsMap = await getFormConfigs(this.approveFormId);
            this.forms = [];
            for (var key in formsMap) {
                if (formsMap[key]) {
                    this.forms.push(formsMap[key]);
                    this.renderdefaultForm(formsMap[key]);
                }
            }
        },
        async initFormData () {
            let modelTree = await getApplicationModelTreeList({
                currentPage: 1,
                pageSize: 10000,
                state: 1,
                aopModelType: 1,
                modelType: 0
            });
            if (modelTree) {
                this.appModelsOptions = modelTree;
                if (this.approveFormId !== '') { // 修改
                    this.modelData.modelName = this.approveModelName;
                    this.modelData.remarks = this.approveModelRemark;
                    await this.initApproveData();
                    this.$refs.treeSelect.initParam(this.modelData.modelIds.split(','));
                }
            }
        },
        handleSelectForm (selectObj) {
            let selectedModel = cloneDeep(selectObj);
            this.selectData = [];
            selectedModel.forEach(item => {
                item.modelId = item.id;
                item.id = item.formId;
                item.formName = item.name;
                this.selectData.push(item);
            });
            this.initModelList();
            if (selectObj.length > 0) {
                this.showApproveContent = true;
            } else {
                this.showApproveContent = false;
            }
        },
        async initModelList () {
            await this.initStruct();
            if (this.forms && this.forms.length > 0) {
                this.collapseActiveName = this.forms[0].id;// 默认打开第一个表单
            }
        },
        async initStruct () {
            let formIds = [];
            let modelIds = [];
            this.selectData.forEach(element => {
                formIds.push(element.id);
                modelIds.push(element.modelId);
            });
            this.modelData.formIds = formIds.join(',');
            this.modelData.modelIds = modelIds.join(',');
            let formsMap = await getFormConfigs(formIds.join(','));
            this.forms = [];
            for (var key in formsMap) {
                if (formsMap[key]) {
                    this.forms.push(formsMap[key]);
                    this.renderdefaultForm(formsMap[key]);
                }
            }
        },
        renderdefaultForm (element) {
            let fieldsList = element.fieldsList;
            let values = {};
            let attributes = {};
            for (let index = 0, len = fieldsList.length; index < len; index++) {
                const element = fieldsList[index];
                values[element.id] = '';
                attributes[element.id] = element.type;
            }
            this.formData.push({
                formId: element.id,
                values: values,
                attributes: attributes,
                colSpan: element.colSpan ? element.colSpan : 1,
                ext1: element.ext1 ? Number(element.ext1) : 0
            });
        },
        saveData () {
            if (this.modelData.modelName === '') {
                this.$message.error('请输入模型名称');
                return;
            }
            if (this.modelData.formIds.length < 1) {
                this.$message.error('请选择审批表单');
                return;
            }
            this.$emit('sendAddApproveData', this.modelData);
        }
    }
};
</script>
<style lang="less" scoped="scoped">
    .approve-model-content{
        height: 90%;
        width: 96%;
        top: 2vh;
        overflow: auto;
        position: absolute;
        .opera-tit-btn{
            display: flex;
            height:6vh;
            line-height: 6vh;
            .tit{
                flex: 1;
                font-size: 1.25rem;
                font-weight: 400;
                text-align: left;
            }
            .btn{
                flex: 1;
                text-align: right;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/ApproveModel/ApproveModel.vue